import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class IsgHelperService {

  constructor() { }

  // will return an empty string if the input is not a valid guid
  public getValidGUID(str: string | null | undefined): string {

    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);

    if (!(str)) {
      return "";
    }

    if (regex.test(str) == true) {
      return str;
    }
    else {
      return "";
    }
  }
}
